import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './login.service';

/**
 * Interfaz para la compra
 */
interface PurchaseRequest {
    products: Array<{
        id: number;
        quantity: number;
    }>;
    // Otros campos necesarios para la compra
}

@Injectable({
    providedIn: 'root'
})
export class CartService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private loginService: LoginService
    ) {
        this.apiUrl = environment.API_BACK;
    }

    private getLang(): string {
        return sessionStorage.getItem('lang') || 'es';
    }

    private handleError(error: HttpErrorResponse) {
        console.error('[CartService] Error en la petición:', error);

        if (error.status === 401) {
            this.loginService.logout();
            return throwError(() => new Error('Sesión expirada o inválida'));
        }

        return throwError(() => new Error(error.message || 'Error en el servidor'));
    }

    /**
     * Envía una solicitud de compra
     * @param purchase Datos de la compra a realizar
     * @returns Observable con la respuesta del servidor
     */
    public sendBuy(purchase: PurchaseRequest): Observable<any> {
        console.debug('[CartService] Enviando solicitud de compra:', purchase);
        const url = `${this.apiUrl}purchase/add?lang=${this.getLang()}`;

        return this.http.post(url, purchase, {
            headers: this.loginService.getHeaders(true)
        }).pipe(
            map(response => {
                console.debug('[CartService] Respuesta compra:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }
}
